'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = function (theme) {
  return {
    buttonsWrapper: {
      textAlign: 'right',
      '& div': {
        marginLeft: theme.modal.spacingButton
      },
      '&.disabled': {
        opacity: theme.disabledOpacity
      },
      '&.hidden': {
        display: 'none'
      }
    }
  };
};